// extracted by mini-css-extract-plugin
module.exports = {"container":"OurServices_container___0NPL"};